import { useList, useDetail, useCreate, useUpdate, useDelete, fetchApi } from "@inmagik/react-crud"
import { Persona } from "../types"
import { API_URL } from "../constants"
import { useCallback } from "react"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"
import { useAuth } from "../auth"

export function usePersoneList(
  params: // accept also list of ids
  Record<string, string | number | Array<number>> = {},
  enabled = true
) {
  return useList<Persona>(`${API_URL}/admin/persone`, {
    query: params,
    reactQuery: {
      enabled: enabled,
      queryKey: ["persone", params],
    },
  })
}

export function usePersona(id: number | undefined) {
  return useDetail<Persona>(`${API_URL}/admin/persone`, id?.toString())
}

export function usePersonaLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/persone/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Persona>
  }, [])
}

export function usePersoneLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/persone?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Persona[] }>
  }, [])
}

export function usePersonaCreate() {
  return useCreate<Persona>(`${API_URL}/admin/persone`)
}

export function usePersonaUpdate() {
  return useUpdate<Persona>(`${API_URL}/admin/persone`)
}

export function usePersonaDelete() {
  return useDelete(`${API_URL}/admin/persone`)
}
